<template lang="pug">
  main
    NavBarInventario
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.is-size-3 Artículos de Sistemas en Almacenes
              | &nbsp
              a.button.is-dark.is-rounded(@click='backPage')
                i.fas.fa-times
            br
        .columns
          .column.is-8
            input#all.is-checkradio.is-black(type='radio', value='allC' v-model='filter')
            label.is-size-6(for='all') Todos
            input#irgeC.is-checkradio.is-black(type='radio', value='IRGEc' v-model='filter')
            label.is-size-6(for='irgeC') IRGE
            input#tpaC.is-checkradio.is-black(type='radio', value='TPAc' v-model='filter')
            label.is-size-6(for='tpaC') TPA
            input#corpC.is-checkradio.is-black(type='radio', value='CORPc' v-model='filter')
            label.is-size-6(for='corpC') CORPO
            input#ductoC.is-checkradio.is-black(type='radio', value='DUCTOc' v-model='filter')
            label.is-size-6(for='ductoC') Ducto
          .column.is-2.is-offset-2.has-text-right
            router-link.a.button.is-black(to="/Inventario/Alta")
              | Nuevo Artículo
        .columns
          .column.is-6
            input#tpaH.is-checkradio.is-black(type='radio', value='TPA' v-model='filter')
            label.is-size-6(for='tpaH') TPA GIA
            input#eb04H.is-checkradio.is-black(type='radio', value='EB04' v-model='filter')
            label.is-size-6(for='eb04H') EB04 GIA
            input#corpH.is-checkradio.is-black(type='radio', value='CORP' v-model='filter')
            label.is-size-6(for='corpH') CORPO GIA
          .column.is-5.is-offset-1
            .field
              .control
                input.input.is-primary(
                  type='text', 
                  placeholder='Buscar por Marca|Categoría|Modelo|Serie',
                  v-model="query_articulos",
                )
        .columns
          .column.is-3(v-show="resultadoFilter !== ''")
            span.tag.is-warning
              | {{ resultadoFilter }}
        .columns
          .column.is-12
            TbAlmacenes(:articulos="articulosShow")
</template>

<script>
  import Loader from '../shared/Loader.vue'
  import NavBarInventario from './layout/NavBarInventario.vue'
  import InventarioServices from '../../services/inventario/inventario'
  import TbAlmacenes from './shared/TbAlmacenes.vue'
  import { mapState } from 'vuex'
  export default {
    name: 'ContainerAlmacenes',
    components: { Loader, NavBarInventario, TbAlmacenes },
    data() {
      return {
        isLoading: true,
        articulos: [],
        articulosShow: [],
        filter: 'allC',
        resultadoFilter: '',
        query_articulos: '',
      }
    },
    watch: {
      filter() {
        switch(this.filter) {
          case 'IRGEc':
            this.articulosShow = this.articulos.filter( art => art.oficina === 'IRGE-ALM')
            break
          case 'TPAc':
            this.articulosShow = this.articulos.filter( art => art.oficina === 'TPA-ALM')
            break
          case 'CORPc':
            this.articulosShow = this.articulos.filter( art => art.oficina === 'CORP-ALM')
            break
          case 'EB04c':
            this.articulosShow = this.articulos.filter( art => art.oficina === 'EB04-ALM')
            break
          case 'EB04':
            this.articulosShow = this.articulos.filter( art => art.oficina === 'EB04-ALG')
            break
          case 'TPA':
            this.articulosShow = this.articulos.filter( art => art.oficina === 'TPA-ALS')
            break
          case 'CORP':
            this.articulosShow = this.articulos.filter( art => art.oficina === 'CORP-ALG')
            break
          case 'DUCTOc':
            this.articulosShow = this.articulos.filter( art => art.oficina === 'EB00-ALM' || art.oficina === 'EB01-ALM' || art.oficina === 'EB02-ALM' || art.oficina === 'EB03-ALM' || art.oficina === 'EB04-ALM')
            break
          case 'allC':
            this.articulosShow = this.articulos
            break
          default:
            break
        }
      },
      query_articulos() {
        this.resultadoFilter = ''
        if (this.query_articulos !== '') {
          this.articulosShow = []
          const QUERY_ARTICULOS = this.query_articulos.toUpperCase()
          const articulos = this.articulos.filter( arts => {
            return `${arts.modelo} ${arts.marca} ${arts.categoria} ${arts.subcategoria} ${arts.serie}`.toUpperCase().includes(QUERY_ARTICULOS)
          })
          this.articulosShow = articulos
          this.resultadoFilter = `Coinicidencias: ${this.articulosShow.length} artículo${this.articulosShow.length == 1 ? '' : 's'}`
        } else {
          this.articulosShow = this.articulos
        }
      },
    },
    methods: {
      iniciarComponente() {
        this.obtenerArticulos()
      },

      obtenerArticulos () {
        InventarioServices.getArticulosAlmacenArea('s')
          .then( data => {
            this.articulos = data.map(this.convertirArticulos)
            this.articulosShow = this.articulos
            this.isLoading = false
          })
          .catch( e => {
            this.isLoading = false
            this.displayToast(`Error: ${e.message}`, 'ban', 'OK')
          })
      },

      convertirArticulos (art) {
        return {
          ...art,
          id: parseInt(art.id),
          cajaChica: parseInt(art.cajaChica),
          estado: parseInt(art.estado),
          garantia: parseInt(art.garantia),
        }
      },

      displayToast(text, icon, actionText) {
        let toast = this.$toasted.show(text, { 
          theme: "toasted-primary", 
          position: "bottom-right", 
          duration : null,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      },
      backPage () {
        this.$router.back()
      }
    },

    created () {
      this.iniciarComponente()
    },
    
    computed: {
      ...mapState(['userLogin', 'almacenSelect'])
    }

  }
</script>

<style scoped>
  .column-blanco {
    padding-bottom: 100px;
  }
</style>


// WEBPACK FOOTER //
// src/components/inventario_Componentes/ContainerAlmacenes.vue